// This file is auto-generated. Do not edit!

export default [
  {
    bpt: "0x0052688295413b32626D226a205b95cDB337DE86",
    id: "0x0052688295413b32626d226a205b95cdb337de860002000000000000000003d1",
    name: "20ARB-80USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x912CE59144191C1204E64559FE8253a0e49E6548",
        symbol: "ARB",
      },
      {
        address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x055242438D0Eca5DD98878c32a3033d19f73C935",
    id: "0x055242438d0eca5dd98878c32a3033d19f73c935000200000000000000000046",
    name: "50LEVR-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x77De4df6F2d87Cc7708959bCEa45d58B0E8b8315",
        symbol: "LEVR",
      },
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x05f0a172608853d5431C69888A0a559886a3319f",
    id: "0x05f0a172608853d5431c69888a0a559886a3319f0002000000000000000004f0",
    name: "ARSWETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2EADCE7EBDEDF3c7291F1f658208A2720Ff4B74d",
        symbol: "ARS",
      },
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x0adeb25cb5920d4f7447af4a0428072EdC2cEE22",
    id: "0x0adeb25cb5920d4f7447af4a0428072edc2cee2200020000000000000000004a",
    name: "80GMX-20WETH",
    type: "Weighted",
    gauge: "0x4Fd63966879300caFafBB35D157dC5229278Ed23",
    tokens: [
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
      {
        address: "0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a",
        symbol: "GMX",
      },
    ],
  },
  {
    bpt: "0x125bC5a031B2Db6733bfa35d914ffa428095978B",
    id: "0x125bc5a031b2db6733bfa35d914ffa428095978b000200000000000000000514",
    name: "ECLP-AUSDC-AUSDT",
    type: "GyroE",
    gauge: "0x2b52a321Fc2ab77e9fC8488D792BB3CaEA966c0b",
    tokens: [
      {
        address: "0x7CFaDFD5645B50bE87d546f42699d863648251ad",
        symbol: "stataArbUSDCn",
      },
      {
        address: "0xb165a74407fE1e519d6bCbDeC1Ed3202B35a4140",
        symbol: "stataArbUSDT",
      },
    ],
  },
  {
    bpt: "0x1533A3278f3F9141d5F820A184EA4B017fce2382",
    id: "0x1533a3278f3f9141d5f820a184ea4b017fce2382000000000000000000000016",
    name: "B-staBAL-3",
    type: "Stable",
    gauge: "0xD997f35c9b1281B82C8928039D14CdDaB5e13c20",
    tokens: [
      {
        address: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
        symbol: "DAI",
      },
      {
        address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
        symbol: "USDT",
      },
      {
        address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x17a35E3D578797e34131d10e66c11170848c6Da1",
    id: "0x17a35e3d578797e34131d10e66c11170848c6da100010000000000000000001d",
    name: "33 1S-BTC 33 1L-BTC 33 USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x052814194f459aF30EdB6a506eABFc85a4D99501",
        symbol: "1S-BTC/USD",
      },
      {
        address: "0x1616bF7bbd60E57f961E83A602B6b9Abb6E6CAFc",
        symbol: "1L-BTC/USD",
      },
      {
        address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x1e713B6b93fc31e8F59de1f757043964d9dDC5Fa",
    id: "0x1e713b6b93fc31e8f59de1f757043964d9ddc5fa0002000000000000000005c7",
    name: "ECLP-GYD-USDC",
    type: "GyroE",
    gauge: "0x571257922a187908052B80BFd4F771b2d3b1F801",
    tokens: [
      {
        address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
        symbol: "USDC",
      },
      {
        address: "0xCA5d8F8a8d49439357d3CF46Ca2e720702F132b8",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0x1ed1e6FA76E3dD9eA68D1FD8c4b8626EA5648DfA",
    id: "0x1ed1e6fa76e3dd9ea68d1fd8c4b8626ea5648dfa0002000000000000000005cb",
    name: "20wstETH-80TANGO",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x5979D7b546E38E414F7E9822514be443A4800529",
        symbol: "wstETH",
      },
      {
        address: "0xC760F9782F8ceA5B06D862574464729537159966",
        symbol: "TANGO",
      },
    ],
  },
  {
    bpt: "0x260Dbd54D87A10A0Fc9D08622Ebc969A3Bf4E6bb",
    id: "0x260dbd54d87a10a0fc9d08622ebc969a3bf4e6bb000200000000000000000536",
    name: "jitoSOL/wstETH",
    type: "Weighted",
    gauge: "0xfA7C98b893b26e99EFb53110B1B72FFAaC607b69",
    tokens: [
      {
        address: "0x5979D7b546E38E414F7E9822514be443A4800529",
        symbol: "wstETH",
      },
      {
        address: "0x83e1d2310Ade410676B1733d16e89f91822FD5c3",
        symbol: "JitoSOL",
      },
    ],
  },
  {
    bpt: "0x2b51E0443bE2656d0AFb982695695254E2cACE2D",
    id: "0x2b51e0443be2656d0afb982695695254e2cace2d0002000000000000000005ef",
    name: "ECLP-wstUSR-GYD",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x66CFbD79257dC5217903A36293120282548E2254",
        symbol: "wstUSR",
      },
      {
        address: "0xCA5d8F8a8d49439357d3CF46Ca2e720702F132b8",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0x2D42910D826e5500579D121596E98A6eb33C0a1b",
    id: "0x2d42910d826e5500579d121596e98a6eb33c0a1b0002000000000000000003d9",
    name: "50WETH-50ARB",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
      {
        address: "0x912CE59144191C1204E64559FE8253a0e49E6548",
        symbol: "ARB",
      },
    ],
  },
  {
    bpt: "0x2e8Ea681FD59c9dc5f32B29de31F782724EF4DcB",
    id: "0x2e8ea681fd59c9dc5f32b29de31f782724ef4dcb0001000000000000000004bc",
    name: "50GOLD-25USDC-25WSTETH",
    type: "Weighted",
    gauge: "0xcF853F14EF6111435Cb39c0C43C66366cc6300F1",
    tokens: [
      {
        address: "0x5979D7b546E38E414F7E9822514be443A4800529",
        symbol: "wstETH",
      },
      {
        address: "0x8b5e4C9a188b1A187f2D1E80b1c2fB17fA2922e1",
        symbol: "GOLD",
      },
      {
        address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x32dF62dc3aEd2cD6224193052Ce665DC18165841",
    id: "0x32df62dc3aed2cd6224193052ce665dc181658410002000000000000000003bd",
    name: "RDNT-WETH",
    type: "Weighted",
    gauge: "0xcf9f895296F5e1D66a7D4dcf1d92e1B435E9f999",
    tokens: [
      {
        address: "0x3082CC23568eA640225c2467653dB90e9250AaA0",
        symbol: "RDNT",
      },
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x36bf227d6BaC96e2aB1EbB5492ECec69C691943f",
    id: "0x36bf227d6bac96e2ab1ebb5492ecec69c691943f000200000000000000000316",
    name: "B-wstETH-WETH-Stable",
    type: "MetaStable",
    gauge: "0x8F0B53F3BA19Ee31C0A73a6F6D84106340fadf5f",
    tokens: [
      {
        address: "0x5979D7b546E38E414F7E9822514be443A4800529",
        symbol: "wstETH",
      },
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x3a4c6D2404b5eb14915041e01F63200a82f4a343",
    id: "0x3a4c6d2404b5eb14915041e01f63200a82f4a343000200000000000000000065",
    name: "50STG-50USDC",
    type: "Weighted",
    gauge: "0xC422B5407C7717a3259A59738E05e74d6AA3302A",
    tokens: [
      {
        address: "0x6694340fc020c5E6B96567843da2df01b2CE1eb6",
        symbol: "STG",
      },
      {
        address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x3f09C77B19AD8Bb527355ec32d5ce98421fec2E3",
    id: "0x3f09c77b19ad8bb527355ec32d5ce98421fec2e30000000000000000000004b2",
    name: "axlBAL/BAL",
    type: "ComposableStable",
    gauge: "0xfC83DbD818e897cF1F9527254A11bF0e6E1cb970",
    tokens: [
      {
        address: "0x040d1EdC9569d4Bab2D15287Dc5A4F10F56a56B8",
        symbol: "BAL",
      },
      {
        address: "0x11C1879227D463b60db18C17c20aE739aE8E961a",
        symbol: "axlBAL",
      },
    ],
  },
  {
    bpt: "0x423A1323c871aBC9d89EB06855bF5347048Fc4A5",
    id: "0x423a1323c871abc9d89eb06855bf5347048fc4a5000000000000000000000496",
    name: "4POOL-BPT",
    type: "ComposableStable",
    gauge: "0xa14453084318277b11d38FbE05D857A4f647442B",
    tokens: [
      {
        address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
        symbol: "USDC",
      },
      {
        address: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
        symbol: "DAI",
      },
      {
        address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
        symbol: "USDT",
      },
      {
        address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x451B0Afd69ACe11Ec0AC339033D54d2543b088a8",
    id: "0x451b0afd69ace11ec0ac339033d54d2543b088a80000000000000000000004d5",
    name: "plsRDNT-Stable",
    type: "ComposableStable",
    gauge: "0x40F6bE0b26B229C4C3b2C3344e91f8eEe22a62fF",
    tokens: [
      {
        address: "0x3082CC23568eA640225c2467653dB90e9250AaA0",
        symbol: "RDNT",
      },
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
      {
        address: "0x6dbF2155B0636cb3fD5359FCcEFB8a2c02B6cb51",
        symbol: "plsRDNT",
      },
    ],
  },
  {
    bpt: "0x46472CBA35E6800012aA9fcC7939Ff07478C473E",
    id: "0x46472cba35e6800012aa9fcc7939ff07478c473e00020000000000000000056c",
    name: "ECLP-GHO-AUSDC",
    type: "GyroE",
    gauge: "0x6e654787251ae77Fe1873f93A5f220E00afa90E8",
    tokens: [
      {
        address: "0x7CFaDFD5645B50bE87d546f42699d863648251ad",
        symbol: "stataArbUSDCn",
      },
      {
        address: "0x7dfF72693f6A4149b17e7C6314655f6A9F7c8B33",
        symbol: "GHO",
      },
    ],
  },
  {
    bpt: "0x49b2De7d214070893c038299a57BaC5ACb8B8A34",
    id: "0x49b2de7d214070893c038299a57bac5acb8b8a340001000000000000000004be",
    name: "GOLD-BAL-AURA-wstETH",
    type: "Weighted",
    gauge: "0x159be31493C26F8F924b3A2a7F428C2f41247e83",
    tokens: [
      {
        address: "0x040d1EdC9569d4Bab2D15287Dc5A4F10F56a56B8",
        symbol: "BAL",
      },
      {
        address: "0x1509706a6c66CA549ff0cB464de88231DDBe213B",
        symbol: "AURA",
      },
      {
        address: "0x5979D7b546E38E414F7E9822514be443A4800529",
        symbol: "wstETH",
      },
      {
        address: "0x8b5e4C9a188b1A187f2D1E80b1c2fB17fA2922e1",
        symbol: "GOLD",
      },
    ],
  },
  {
    bpt: "0x4f14D06CB1661cE1DC2A2f26A10A7Cd94393b29C",
    id: "0x4f14d06cb1661ce1dc2a2f26a10a7cd94393b29c000200000000000000000097",
    name: "20fxUSD-80FOREX",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x8616E8EA83f048ab9A5eC513c9412Dd2993bcE3F",
        symbol: "fxUSD",
      },
      {
        address: "0xDb298285FE4C5410B05390cA80e8Fbe9DE1F259B",
        symbol: "FOREX",
      },
    ],
  },
  {
    bpt: "0x542F16DA0efB162D20bF4358EfA095B70A100f9E",
    id: "0x542f16da0efb162d20bf4358efa095b70a100f9e000000000000000000000436",
    name: "2BTC",
    type: "ComposableStable",
    gauge: "0xb438c6cc53315FfA3fcD1bc8b27d6c3155b0B56A",
    tokens: [
      {
        address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
        symbol: "WBTC",
      },
      {
        address: "0x6c84a8f1c29108F47a79964b5Fe888D4f4D0dE40",
        symbol: "tBTC",
      },
    ],
  },
  {
    bpt: "0x569061E2D807881F4A33E1cbE1063bc614cB75a4",
    id: "0x569061e2d807881f4a33e1cbe1063bc614cb75a40002000000000000000002bb",
    name: "80Y2K-20WETH",
    type: "Weighted",
    gauge: "0xC7188b7779feB7DBDeD3913F3671188491cb61B3",
    tokens: [
      {
        address: "0x65c936f008BC34fE819bce9Fa5afD9dc2d49977f",
        symbol: "Y2K",
      },
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x59B7867F6B127070378feeb328e2Ffe6AAb67525",
    id: "0x59b7867f6b127070378feeb328e2ffe6aab6752500010000000000000000009b",
    name: "33 USDC 33 3L-ETH+USDC 33 3S-ETH+USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4d00c6dD5D5299082a1062C9B480af2FC698f6Eb",
        symbol: "3L-ETH/USD+USDC",
      },
      {
        address: "0x7fF6132ef2Abf89B6eC509947eB2c1ee9Da29F26",
        symbol: "3S-ETH/USD+USDC",
      },
      {
        address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x5cEd962AfbFb7E13Fb215DeFc2b027678237AA3A",
    id: "0x5ced962afbfb7e13fb215defc2b027678237aa3a000200000000000000000011",
    name: "B-80NDX-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
      {
        address: "0xB965029343D55189c25a7f3e0c9394DC0F5D41b1",
        symbol: "NDX",
      },
    ],
  },
  {
    bpt: "0x64541216bAFFFEec8ea535BB71Fbc927831d0595",
    id: "0x64541216bafffeec8ea535bb71fbc927831d0595000100000000000000000002",
    name: "B-33WETH-33WBTC-33USDC",
    type: "Weighted",
    gauge: "0x820A9F3897B2aBFeEcE95dF4aA71D8a4fb448C3B",
    tokens: [
      {
        address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
        symbol: "WBTC",
      },
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
      {
        address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x64ABEAe398961c10cBB50eF359f1dB41fc3129ff",
    id: "0x64abeae398961c10cbb50ef359f1db41fc3129ff000200000000000000000526",
    name: "80AURA-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x1509706a6c66CA549ff0cB464de88231DDBe213B",
        symbol: "AURA",
      },
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x651e00FfD5eCfA7F3d4F33d62eDe0a97Cf62EdE2",
    id: "0x651e00ffd5ecfa7f3d4f33d62ede0a97cf62ede2000200000000000000000006",
    name: "B-80LINK-20WETH",
    type: "Weighted",
    gauge: "0x4BAC8bccBF0fC39e8Cc086397C39578102c9C366",
    tokens: [
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
      {
        address: "0xf97f4df75117a78c1A5a0DBb814Af92458539FB4",
        symbol: "LINK",
      },
    ],
  },
  {
    bpt: "0x6AF7bCA454f3C8165225Ed46FD4d78cc90E81fAA",
    id: "0x6af7bca454f3c8165225ed46fd4d78cc90e81faa00020000000000000000040c",
    name: "UPDOGE-BPT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x5979D7b546E38E414F7E9822514be443A4800529",
        symbol: "wstETH",
      },
      {
        address: "0x8B65C028B223b83b13FCF1d1F0873320e6CAB132",
        symbol: "UPDOGE",
      },
    ],
  },
  {
    bpt: "0x6ce1D1e46548ef657f8D7Ebddfc4BEaDB04F72f3",
    id: "0x6ce1d1e46548ef657f8d7ebddfc4beadb04f72f30002000000000000000005a1",
    name: "ECLP-wstETH-GYD",
    type: "GyroE",
    gauge: "0x654a17A779B82BA7739cD3Adb2052e039c4366C5",
    tokens: [
      {
        address: "0x5979D7b546E38E414F7E9822514be443A4800529",
        symbol: "wstETH",
      },
      {
        address: "0xCA5d8F8a8d49439357d3CF46Ca2e720702F132b8",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0x6e822c64c00393b2078f2a5BB75c575aB505B55c",
    id: "0x6e822c64c00393b2078f2a5bb75c575ab505b55c000200000000000000000548",
    name: "ECLP-GYD-AUSDC",
    type: "GyroE",
    gauge: "0x052597B6633814a0a6eA9020eE46E25Aa6936E49",
    tokens: [
      {
        address: "0x7CFaDFD5645B50bE87d546f42699d863648251ad",
        symbol: "stataArbUSDCn",
      },
      {
        address: "0xCA5d8F8a8d49439357d3CF46Ca2e720702F132b8",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0x6ee86e032173716a41818e6d6D320a752176D697",
    id: "0x6ee86e032173716a41818e6d6d320a752176d69700010000000000000000001c",
    name: "33 1S-ETH 33 1L-ETH 33 USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x38c0a5443c7427e65A9Bf15AE746a28BB9a052cc",
        symbol: "1L-ETH/USD",
      },
      {
        address: "0xf581571DBcCeD3A59AaaCbf90448E7B3E1704dcD",
        symbol: "1S-ETH/USD",
      },
      {
        address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x7272163A931DaC5BBe1CB5feFaF959BB65F7346F",
    id: "0x7272163a931dac5bbe1cb5fefaf959bb65f7346f000200000000000000000549",
    name: "ECLP-GYD-AUSDT",
    type: "GyroE",
    gauge: "0xd9647eb5D6457bd7Adb39B335ab89eC3a1Ea6d09",
    tokens: [
      {
        address: "0xb165a74407fE1e519d6bCbDeC1Ed3202B35a4140",
        symbol: "stataArbUSDT",
      },
      {
        address: "0xCA5d8F8a8d49439357d3CF46Ca2e720702F132b8",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0x7F244b47C63E9Ca33A58E6550bfd1D3dC806Ce55",
    id: "0x7f244b47c63e9ca33a58e6550bfd1d3dc806ce550002000000000000000003fa",
    name: "CHEESE",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
      {
        address: "0xD2cC61A36c31425B3Eb9bBEeCcE74A82a2e32E27",
        symbol: "RATS",
      },
    ],
  },
  {
    bpt: "0x80f4140b740556BeFb27C19D37bc8717b48C2AE8",
    id: "0x80f4140b740556befb27c19d37bc8717b48c2ae80002000000000000000005f0",
    name: "ECLP-syrupUSDC-GYD",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x41CA7586cC1311807B4605fBB748a3B8862b42b5",
        symbol: "syrupUSDC",
      },
      {
        address: "0xCA5d8F8a8d49439357d3CF46Ca2e720702F132b8",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0x820b69faD931d4b4Bf14E70fF234A8390F6A0658",
    id: "0x820b69fad931d4b4bf14e70ff234a8390f6a0658000200000000000000000547",
    name: "ECLP-GYD-AUSDC",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x7CFaDFD5645B50bE87d546f42699d863648251ad",
        symbol: "stataArbUSDCn",
      },
      {
        address: "0xCA5d8F8a8d49439357d3CF46Ca2e720702F132b8",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0x835772Bab114563746da80806930A9E37aa85344",
    id: "0x835772bab114563746da80806930a9e37aa853440002000000000000000004c0",
    name: "D2D-rETH",
    type: "Weighted",
    gauge: "0x089a2E069700B0f2B16f69A6e02b01818ce22e7d",
    tokens: [
      {
        address: "0xDD4AB36f31891fF25A69121FCCC732d93eB976Dd",
        symbol: "D2D",
      },
      {
        address: "0xEC70Dcb4A1EFa46b8F2D97C310C9c4790ba5ffA8",
        symbol: "rETH",
      },
    ],
  },
  {
    bpt: "0x85a7023F3d287F849b6c8223aF1E783383A391a8",
    id: "0x85a7023f3d287f849b6c8223af1e783383a391a8000200000000000000000044",
    name: "50LEVR-50DAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x77De4df6F2d87Cc7708959bCEa45d58B0E8b8315",
        symbol: "LEVR",
      },
      {
        address: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
        symbol: "DAI",
      },
    ],
  },
  {
    bpt: "0x88E2c969e2a1C69c16d1dcd9f8ACdE4c6Ab3838a",
    id: "0x88e2c969e2a1c69c16d1dcd9f8acde4c6ab3838a0002000000000000000004c1",
    name: "80FOX-20WETH",
    type: "Weighted",
    gauge: "0x901079a908FD3a228a1dc7548dd67e10a911E580",
    tokens: [
      {
        address: "0x6bcc14B02CD624EbE1a8A665Cb6d4067Aa097230",
        symbol: "FOX",
      },
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x8bc65Eed474D1A00555825c91FeAb6A8255C2107",
    id: "0x8bc65eed474d1a00555825c91feab6a8255c2107000000000000000000000453",
    name: "DOLA/USDC BPT",
    type: "ComposableStable",
    gauge: "0xd956246EA5b06DEa930F0A7feC1FFf000436e3f2",
    tokens: [
      {
        address: "0x6A7661795C374c0bFC635934efAddFf3A7Ee23b6",
        symbol: "DOLA",
      },
      {
        address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x934d3c04f0603332d6e182Bf33289bc4c905Fc22",
    id: "0x934d3c04f0603332d6e182bf33289bc4c905fc22000200000000000000000584",
    name: "B-20WETH-80A51",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
      {
        address: "0xB3F13B0C61d65D67D7D6215d70C89533ee567A91",
        symbol: "A51",
      },
    ],
  },
  {
    bpt: "0x996616BDe0CB4974e571f17d31c844da2BD177f8",
    id: "0x996616bde0cb4974e571f17d31c844da2bd177f8000100000000000000000018",
    name: "50 wETH 33 3S-ETH 17 3L-ETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x7d7E4f49a29dDA8b1eCDcf8a8bc85EdcB234E997",
        symbol: "3S-ETH/USD",
      },
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
      {
        address: "0xaA846004Dc01b532B63FEaa0b7A0cB0990f19ED9",
        symbol: "3L-ETH/USD",
      },
    ],
  },
  {
    bpt: "0x9bFCD4189Cf9062697746CE292350f42fDEE457C",
    id: "0x9bfcd4189cf9062697746ce292350f42fdee457c0002000000000000000004d6",
    name: "50DFX-50WETH",
    type: "Weighted",
    gauge: "0x574c2146091Cced305A7ABa82d097DE36b736fac",
    tokens: [
      {
        address: "0x27f485b62C4A7E635F561A87560Adf5090239E93",
        symbol: "DFX",
      },
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xA83B8D30F61D7554aD425D8067D8bA6EaeB6b042",
    id: "0xa83b8d30f61d7554ad425d8067d8ba6eaeb6b042000200000000000000000525",
    name: "70WETH-30ARB",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
      {
        address: "0x912CE59144191C1204E64559FE8253a0e49E6548",
        symbol: "ARB",
      },
    ],
  },
  {
    bpt: "0xAbf8DB2B16c2C483691f3B19fa24DD1bDc60abB6",
    id: "0xabf8db2b16c2c483691f3b19fa24dd1bdc60abb60002000000000000000005f2",
    name: "ECLP-WETH-GYD-dyn",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
      {
        address: "0xCA5d8F8a8d49439357d3CF46Ca2e720702F132b8",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0xAf0561B26Ac83418fC889590B4D7C28D73DE6718",
    id: "0xaf0561b26ac83418fc889590b4d7c28d73de67180002000000000000000005f1",
    name: "ECLP-WETH-USDC-dyn",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
      {
        address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0xAF8912a3C4f55a8584B67DF30ee0dDf0e60e01f8",
    id: "0xaf8912a3c4f55a8584b67df30ee0ddf0e60e01f80002000000000000000004fc",
    name: "50OLAS-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x064F8B858C2A603e1b106a2039f5446D32dc81c1",
        symbol: "OLAS",
      },
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xb3028Ca124B80CFE6E9CA57B70eF2F0CCC41eBd4",
    id: "0xb3028ca124b80cfe6e9ca57b70ef2f0ccc41ebd40002000000000000000000ba",
    name: "50MAGIC-50USDC",
    type: "Weighted",
    gauge: "0xeF767E740D83d410794519c2F93Db32e44359a5C",
    tokens: [
      {
        address: "0x539bdE0d7Dbd336b79148AA742883198BBF60342",
        symbol: "MAGIC",
      },
      {
        address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0xB340B6b1a34019853Cb05B2De6eE8ffD0B89a008",
    id: "0xb340b6b1a34019853cb05b2de6ee8ffd0b89a008000100000000000000000036",
    name: "33DPX-33RDPX-33WETH",
    type: "Weighted",
    gauge: "0x0584AacCfAebA41c75b0Adb27613057832Fc6C56",
    tokens: [
      {
        address: "0x32Eb7902D4134bf98A28b963D26de779AF92A212",
        symbol: "RDPX",
      },
      {
        address: "0x6C2C06790b3E3E3c38e12Ee22F8183b37a13EE55",
        symbol: "DPX",
      },
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xB5B77F1AD2B520df01612399258E7787aF63025D",
    id: "0xb5b77f1ad2b520df01612399258e7787af63025d000200000000000000000010",
    name: "MWP",
    type: "Weighted",
    gauge: "0xF0daFdBda705372BF16c8119a6f03699B0016b42",
    tokens: [
      {
        address: "0x4e352cF164E64ADCBad318C3a1e222E9EBa4Ce42",
        symbol: "MCB",
      },
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xC1889C72D99917FD7b957fEd80d4Ea1eBd9e2618",
    id: "0xc1889c72d99917fd7b957fed80d4ea1ebd9e26180001000000000000000000ae",
    name: "25BAL-25WBTC-25PHONON-25WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x040d1EdC9569d4Bab2D15287Dc5A4F10F56a56B8",
        symbol: "BAL",
      },
      {
        address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
        symbol: "WBTC",
      },
      {
        address: "0x39A49bc5017Fc668299Cd32e734C9269aCc35295",
        symbol: "PHONON",
      },
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xc2F082d33b5B8eF3A7E3de30da54EFd3114512aC",
    id: "0xc2f082d33b5b8ef3a7e3de30da54efd3114512ac000200000000000000000017",
    name: "B-80PICKLE-20WETH",
    type: "Weighted",
    gauge: "0x49F4aDD038E2bf8aF8b38F4909B34438CfC09b4C",
    tokens: [
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
      {
        address: "0x965772e0E9c84b6f359c8597C891108DcF1c5B1A",
        symbol: "PICKLE",
      },
    ],
  },
  {
    bpt: "0xC61ff48f94D801c1ceFaCE0289085197B5ec44F0",
    id: "0xc61ff48f94d801c1ceface0289085197b5ec44f000020000000000000000004d",
    name: "50VSTA-50WETH",
    type: "Weighted",
    gauge: "0x7BA024dA8EeD561d776133412bFfBd1f522A9aff",
    tokens: [
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
      {
        address: "0xa684cd057951541187f288294a1e1C2646aA2d24",
        symbol: "VSTA",
      },
    ],
  },
  {
    bpt: "0xc7FA3A3527435720f0e2a4c1378335324dd4F9b3",
    id: "0xc7fa3a3527435720f0e2a4c1378335324dd4f9b3000200000000000000000459",
    name: "55auraBal-45wsteth",
    type: "Weighted",
    gauge: "0x82d2c7B67Eaa5028c89BE86CeA8e1DF5bd2119A1",
    tokens: [
      {
        address: "0x223738a747383d6F9f827d95964e4d8E8AC754cE",
        symbol: "auraBAL",
      },
      {
        address: "0x5979D7b546E38E414F7E9822514be443A4800529",
        symbol: "wstETH",
      },
    ],
  },
  {
    bpt: "0xc9f52540976385A84BF416903e1Ca3983c539E34",
    id: "0xc9f52540976385a84bf416903e1ca3983c539e34000200000000000000000434",
    name: "50tBTC-50WETH",
    type: "Weighted",
    gauge: "0x011417BBED6FC9cefF36C032D431b0eFcBA7f8B3",
    tokens: [
      {
        address: "0x6c84a8f1c29108F47a79964b5Fe888D4f4D0dE40",
        symbol: "tBTC",
      },
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xcC65A812ce382aB909a11E434dbf75B34f1cc59D",
    id: "0xcc65a812ce382ab909a11e434dbf75b34f1cc59d000200000000000000000001",
    name: "B-60BAL-40WETH",
    type: "Weighted",
    gauge: "0xFAad21203A7856889Cb6eB644AB6864E7253107A",
    tokens: [
      {
        address: "0x040d1EdC9569d4Bab2D15287Dc5A4F10F56a56B8",
        symbol: "BAL",
      },
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xD89746AFfa5483627a87E55713Ec190511439495",
    id: "0xd89746affa5483627a87e55713ec1905114394950002000000000000000000bf",
    name: "DUSDDAI",
    type: "Stable",
    gauge: null,
    tokens: [
      {
        address: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
        symbol: "DAI",
      },
      {
        address: "0xF0B5cEeFc89684889e5F7e0A7775Bd100FcD3709",
        symbol: "DUSD",
      },
    ],
  },
  {
    bpt: "0xdeEaF8B0A8Cf26217261b813e085418C7dD8F1eE",
    id: "0xdeeaf8b0a8cf26217261b813e085418c7dd8f1ee00020000000000000000058f",
    name: "ECLP-sUSDe-GYD",
    type: "GyroE",
    gauge: "0xdEC026525FE4FEF54857bCF551aEA97aBc24A673",
    tokens: [
      {
        address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
        symbol: "sUSDe",
      },
      {
        address: "0xCA5d8F8a8d49439357d3CF46Ca2e720702F132b8",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0xEB3E64Ad9314D20bf943ac72Fb69F272603f9cce",
    id: "0xeb3e64ad9314d20bf943ac72fb69f272603f9cce0002000000000000000004f5",
    name: "80SYNO-20WETH",
    type: "Weighted",
    gauge: "0x26634a2B85831D9916D01Fa6c2489F9c5720600a",
    tokens: [
      {
        address: "0x577Fd586c9E6BA7f2E85E025D5824DBE19896656",
        symbol: "SYNO",
      },
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xef0c116A2818A5b1A5D836A291856A321f43C2Fb",
    id: "0xef0c116a2818a5b1a5d836a291856a321f43c2fb00020000000000000000053a",
    name: "ECLP-WOETH-WETH",
    type: "GyroE",
    gauge: "0x40e86216712cB9871B9C698EA3AFB22f88c00E6e",
    tokens: [
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
      {
        address: "0xD8724322f44E5c58D7A815F542036fb17DbbF839",
        symbol: "WOETH",
      },
    ],
  },
  {
    bpt: "0xF17F1E67bc384E43b4acf69cc032AD086f15f262",
    id: "0xf17f1e67bc384e43b4acf69cc032ad086f15f2620002000000000000000003c6",
    name: "20WETH-80AI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
      {
        address: "0x8d7c2588c365b9e98Ea464b63DBCCDf13ECd9809",
        symbol: "AI",
      },
    ],
  },
] as const
